import { PurgeInvoicesResponse } from "./types";
import axios from "../../../../../../api/axiosInstance";

export const purgeInvoices = async (
  intacctId: string,
): Promise<PurgeInvoicesResponse> => {
  const response = await axios.post<PurgeInvoicesResponse>(
    `/api/private/company/${intacctId}/invoices/purge`,
  );
  return response.data;
};
